import { render, staticRenderFns } from "./iconfontSvg.vue?vue&type=template&id=3afc53ea&scoped=true"
import script from "./iconfontSvg.vue?vue&type=script&lang=js"
export * from "./iconfontSvg.vue?vue&type=script&lang=js"
import style0 from "./iconfontSvg.vue?vue&type=style&index=0&id=3afc53ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc53ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jiang/IdeaProjects/uhi-company-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3afc53ea')) {
      api.createRecord('3afc53ea', component.options)
    } else {
      api.reload('3afc53ea', component.options)
    }
    module.hot.accept("./iconfontSvg.vue?vue&type=template&id=3afc53ea&scoped=true", function () {
      api.rerender('3afc53ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SvgIcon/iconfontSvg.vue"
export default component.exports